import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_payment_status_tag = _resolveComponent("payment-status-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_new_tab_link = _resolveComponent("new-tab-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_payment_list_layout = _resolveComponent("payment-list-layout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_payment_list_layout, {
    page: _ctx.page,
    pages: _ctx.pages,
    "per-page": _ctx.perPage,
    total: _ctx.total,
    onApply: _ctx.apply,
    onReset: _ctx.reset,
    onPageChange: _ctx.setPage
  }, {
    filter: _withCtx(() => [
      _createVNode(_component_el_select, {
        modelValue: _ctx.filters.status,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.status) = $event)),
        multiple: "",
        clearable: "",
        placeholder: "Статус"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (o) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: o.value,
              label: o.label,
              value: o.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.order_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.order_id) = $event)),
        placeholder: "ID заказа",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.gateway_transaction_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.gateway_transaction_id) = $event)),
        placeholder: "ID платежа в шлюзе",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.gateway_type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.gateway_type) = $event)),
        placeholder: "Шлюз (yookassa, payment_invoice)",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.amount_from,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.amount_from) = $event)),
        placeholder: "Сумма от",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.amount_to,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.amount_to) = $event)),
        placeholder: "Сумма до",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.filters.created_from,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.created_from) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "Создан с"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.filters.created_to,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.created_to) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "Создан по"
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: _ctx.items,
        "table-layout": "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "Статус",
            width: "140"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_payment_status_tag, {
                kind: "payment",
                status: row.status
              }, null, 8, ["status"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Сумма",
            width: "140",
            align: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.money(row.amount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Шлюз",
            prop: "gateway_type",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            label: "Способ",
            prop: "method",
            width: "130"
          }),
          _createVNode(_component_el_table_column, {
            label: "ID в шлюзе",
            prop: "gateway_transaction_id",
            "min-width": "260"
          }),
          _createVNode(_component_el_table_column, {
            label: "Создан",
            width: "150"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.dateTime(row.created_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Заказ",
            width: "120"
          }, {
            default: _withCtx(({ row }) => [
              (row.order)
                ? (_openBlock(), _createBlock(_component_new_tab_link, {
                    key: 0,
                    to: { name: 'payments-orders-view', params: { id: row.order.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" № " + _toDisplayString(row.order.number), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["page", "pages", "per-page", "total", "onApply", "onReset", "onPageChange"]))
}